<template>
  <div class="rt-address">
    <el-cascader
      v-model="selectedValue"
      v-bind="$attrs"
      :options="state.addressData"
      :props="props"
      @change="change"
      @blur="blur"
      @focus="focus"
    />
  </div>
</template>

<script>
import { store } from './store';
export default {
  name: 'RtAddress',
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    props: {
      type: Object,
      default: () => {
        return { value: 'id', label: 'name' };
      }
    }
  },
  data() {
    return {
      selectedValue: this.value,
      state: store.state
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    change(val) {
      console.log(val);
      this.$emit('input', val);
    },
    blur() {
      this.$emit('blur');
    },
    focus() {
      this.$emit('focus');
    }
  }
};
</script>
<style lang="less">
.rt-address {
  .el-cascader {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// rtAddress.vue?6b197bcd